export default {
  methods: {
    mapLayerSnowmakingImagesundergroundAdd() {
      this.initPollSnowmakingImagesunderground();
      this.map.addSource("snowmaking-imagesunderground-source", {
        type: "geojson",
        data: this.$store.state.mapLayers.snowmaking.layers.imagesunderground
          .geojson
      });

      this.map.addLayer({
        filter: ["==", "category", "Underground"],
        id: "snowmaking-imagesunderground",
        type: "circle",
        source: "snowmaking-imagesunderground-source",
        paint: {
          "circle-radius": 4,
          "circle-color": "Red",
          "circle-stroke-width": 1,
          "circle-stroke-color": "Black"
        }
      });

      this.map.moveLayer("snowmaking-imagesunderground", "marker-layer-points");
    },
    mapLayerSnowmakingImagesundergroundRemove() {
      this.cancelPollSnowmakingImagesunderground();
      this.map.removeLayer("snowmaking-imagesunderground");
      this.map.removeSource("snowmaking-imagesunderground-source");
    },

    initPollSnowmakingImagesunderground() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/images",
        dept: "snowmaking",
        layer: "imagesunderground",
        token: this.computedAuthToken
      });
      this.pollSnowmakingImagesundergroundInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images",
          dept: "snowmaking",
          layer: "imagesunderground",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollSnowmakingImagesunderground() {
      this.pollSnowmakingImagesundergroundInterval = clearInterval(
        this.pollSnowmakingImagesundergroundInterval
      );
    }
  },
  computed: {
    computedSnowmakingImagesundergroundGeoJson() {
      if (
        this.$store.state.mapLayers.snowmaking.layers.imagesunderground.geojson
          .features
      ) {
        const imagesunderground = this.$store.state.mapLayers.snowmaking.layers
          .imagesunderground.geojson.features;
        let filteredImagesunderground = imagesunderground.filter(
          item => item.properties.hidden != "true"
        );
        return filteredImagesunderground;
      }
    },
    computedSnowmakingImagesundergroundMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.imagesunderground
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.snowmaking.layers.imagesunderground.geojson": {
      handler() {
        if (this.computedSnowmakingImagesundergroundGeoJson) {
          this.mapLayerSnowmakingImagesundergroundRemove();
          this.mapLayerSnowmakingImagesundergroundAdd();
        }
      }
    },
    "$store.state.mapLayers.snowmaking.layers.imagesunderground.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingImagesundergroundAdd();
      } else {
        this.mapLayerSnowmakingImagesundergroundRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollSnowmakingImagesunderground();
  }
};
